/**
 * localStorage keys used by the auth flow.
 *
 * These intentionally keep the exact raw strings the rest of the app already
 * reads/writes, so the migrated views stay byte-for-byte interoperable:
 *   - `userDetails`     — consumed by `@/components/providers/AuthProvider`
 *                         to rehydrate the OTP step after a reload.
 *   - `payerMerchantId` — consumed by `@/lib/payerClient` fallbacks.
 *
 * Access always goes through `safeStorage` (never the raw `localStorage`
 * global) per the storage-discipline lint rule.
 */
export const AUTH_STORAGE_KEYS = {
  USER_DETAILS: "userDetails",
  PAYER_MERCHANT_ID: "payerMerchantId",
} as const;
